import { ChangeEvent, ReactNode } from 'react'
import { Check } from 'lucide-react'
import { cn } from '@global/utils/tailwind'

interface CheckboxProps {
  checked: boolean
  onChange: (e, checked: boolean) => void
  id?: string
  children: ReactNode
  itemPosition?: 'start' | 'center'
}

const Label = ({ className = '', id, children }) => (
  <label htmlFor={id} className={cn('flex items-center cursor-pointer', className)}>
    {children}
  </label>
)

export const Checkbox = ({
  checked,
  onChange,
  id = 'custom-checkbox',
  children,
  itemPosition = 'start',
}: CheckboxProps) => {
  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    onChange(event, event.target.checked)
  }

  return (
    <div className={`inline-flex gap-4 items-${itemPosition}`}>
      <input
        type="checkbox"
        id={id}
        checked={checked}
        onChange={handleChange}
        className="sr-only"
      />
      <label htmlFor={id} className="flex items-center cursor-pointer">
        <div
          className={cn(
            'flex w-[22px] h-[22px] flex-shrink-0 items-center',
            'border bg-white border-cv-blue-200 rounded',
            'transition-all duration-200',
            'hover:shadow-lg hover:shadow-cv-alice-blue-500 hover:border-cv-alice-blue-600',
            checked && 'bg-cv-alice-blue-500 border-cv-alice-blue-600',
          )}
        >
          {checked && <Check size={16} className="text-white m-auto" />}
        </div>
      </label>
      {children}
    </div>
  )
}

Checkbox.Input = Checkbox
Checkbox.Label = Label
